/*
import Homepage from "./Homepage";
export default Homepage;
*/


import HomepageSlider from "./HomepageSlider";
export default HomepageSlider;

